var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-chip',{attrs:{"text-color":"white","small":_vm.small,"color":_vm.statusColor(_vm.status)}},[_c('strong',[_vm._v(_vm._s(_vm.getStatusName(_vm.status)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }